import { Phone, Leaf } from "lucide-react";
import { CONTACT } from "../../lib/content";

export const StickyMobileCTA = () => {
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="lg:hidden fixed bottom-0 left-0 w-full z-40 grid grid-cols-2 border-t border-gold/30 bg-black/95 backdrop-blur-md"
    >
      <a
        href={`tel:${CONTACT.ownerPhone}`}
        data-testid="sticky-call"
        className="flex items-center justify-center gap-2 py-4 text-gold font-semibold uppercase tracking-widest text-xs border-r border-gold/20"
      >
        <Phone size={16} /> Call Now
      </a>
      <a
        href="#estimate"
        data-testid="sticky-estimate"
        className="flex items-center justify-center gap-2 py-4 bg-gold text-black font-bold uppercase tracking-widest text-xs"
      >
        <Leaf size={16} /> Free Estimate
      </a>
    </div>
  );
};
